import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'
import weeklyComparative from '@/app/weekly_sales/store/WeeklyComparative'
import weeklyDetail from '@/app/weekly_sales/store/WeeklyDetail'
import Dimension from '@/app/shared/models/Dimension'

export const NAMESPACE = 'weeklySales'
const INTERNAL_NAMESPACE = NAMESPACE + '/'

const _types = {
  getters: {
    SORT_FIELD: 'GETTER_SORT_FIELD',
    DIMENSION_BY_ID: 'DIMENSION_BY_ID',
    METRIC_OPTIONS: 'METRIC_OPTIONS'
  },
  actions: {
    INIT: 'INIT',
    CHANGE_METRIC: 'CHANGE_METRIC',
    SAVE_FILTERS: 'SAVE_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: {
    [_types.getters.SORT_FIELD]: (state, getters) => {
      const metricsNormalLength = getters[_types.getters.METRICS].normal.length
      const sortField = getters[_types.getters.METRICS].normal[metricsNormalLength - 1]
      return sortField
    },
    [_types.getters.DIMENSION_BY_ID]: (state) => (dimensionId) => {
      return state.dimensions.find((dimension) => dimension.id === dimensionId)
    },
    [_types.getters.METRIC_OPTIONS]: (_) => {
      return [
        {
          caption: 'U',
          value: 'quantity_sold',
          name: 'UNITS',
          tooltip: 'Unidades'
        },
        {
          caption: '$',
          value: 'real_sales_amount',
          name: 'PESOS',
          tooltip: 'Pesos'
        }
      ]
    },
    [_types.getters.METRIC]: (state, getters) => {
      return getters[_types.getters.METRIC_OPTIONS].find(metricOption => metricOption.name === state.metricName)
    }
  },
  actions: {
    async [_types.actions.INIT] ({ commit }, { dataDimensions, metric }) {
      commit(_types.mutations.SET_DIMENSIONS, dataDimensions.map((dimension) => new Dimension(dimension)))
      commit(_types.mutations.SET_METRIC, metric)
    },
    [_types.actions.CHANGE_METRIC] ({ commit }, metric) {
      commit(_types.mutations.SET_METRIC, metric)
    },
    [_types.actions.SAVE_FILTERS] ({ dispatch }, { storeFilters, productFilters }) {
      dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters, productFilters }, { root: true })
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.RESET_SELECTED_FILTERS, null, { root: true })
    }
  },
  mutations: {
    [_types.mutations.SET_DIMENSIONS] (state, dimensions) {
      state.dimensions = dimensions
    },
    [_types.mutations.SET_METRIC] (state, metric) {
      state.metric = metric
    }
  },
  modules: {
    filters,
    weeklyComparative,
    weeklyDetail
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/weekly_sales/store/Index.js